var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowGuide
    ? _c("div", { staticClass: "menu-guide" }, [
        _c("i", { staticClass: "el-icon-caret-left" }),
        _c("div", { staticClass: "title" }, [
          _vm._v(" " + _vm._s(_vm.$t("menuCollected")) + " "),
        ]),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.$t("menuCollectedCont"))),
        ]),
        _c(
          "span",
          { staticClass: "known-btn", on: { click: _vm.handleHide } },
          [_vm._v(_vm._s(_vm.$t("knew")))]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }